import { z } from 'zod/v4';

/** How many files share one value of a column. */
export const FileStatisticItemSchema = z.object({
  name: z.string(),
  count: z.number(),
});

/**
 * How many files one AI processing stage got through, and how many it failed.
 * Replaces a "has extracted text?" pair that only ever reported on the old
 * text-extraction step, and froze when that step was removed.
 */
export const FileProcessingStageSchema = z.object({
  jobType: z.string(),
  processedFiles: z.number(),
  failedFiles: z.number(),
});

/** What `GET /api/admin/files/statistics` answers, each list largest first. */
export const FileStatisticsResponseSchema = z.object({
  byBucketName: z.array(FileStatisticItemSchema),
  byFileType: z.array(FileStatisticItemSchema),
  byContentType: z.array(FileStatisticItemSchema),
  byProcessingStage: z.array(FileProcessingStageSchema),
});

export type FileStatistics = z.infer<typeof FileStatisticsResponseSchema>;
